// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"44":"c5f4da94","99":"31863c69","366":"97b76b4e","381":"9ceab6b4","477":"ac9b7d86","486":"0ae46726","503":"aa1c1414","527":"9c020030","821":"636d7ec7","893":"b2064431","989":"2ea68bf4","995":"40434aee"}[chunkId] + ".js";
};